'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-intl/~/react/react.js
// module id = 677
// module chunks = 0